import { gql } from '@apollo/client'

export const DRAFT_CASE_EMAIL_QUERY = gql`
  query DraftCaseEmail($caseId: ID!, $processingId: ID, $id: ID) {
    draftCaseEmail(caseId: $caseId, processingId: $processingId, id: $id) {
      id
      toAddresses
      ccAddresses
      bccAddresses
      subject
      bodyHtml
      status
      visibleForOtherProcessings
      attachments {
        id
        filename
        url
        signedId
      }
    }
  }
`
